import AnfaelleRoot from "../components/central/anfaelle/AnfaelleRoot";
import TechnischeUntersuchungenRoot from "../components/central/technischeUntersuchungen/TechnischeUntersuchungenRoot";
import DiagnosenRoot from "../components/central/diagnose/DiagnosenRoot";
import EmpfehlungRoot from "../components/central/empfehlung/EmpfehlungRoot";

const routes = [
    {
        path: 'anfaelle',
        component: AnfaelleRoot,
        alias: '',
        name: 'anfaelle'
    },
    {
        path: 'technische-untersuchungen',
        component: TechnischeUntersuchungenRoot,
        name: 'technische-untersuchungen'
    },
    {
        path: 'diagnose',
        component: DiagnosenRoot,
        name: 'diagnose'
    },
    {
        path: 'empfehlung',
        component: EmpfehlungRoot,
        name: 'empfehlung'
    }
]

export default routes
